module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showModalEnviarRegulacao) ? _c('modal-enviar-regulacao', {
    on: {
      "close": function($event) {
        _vm.showModalEnviarRegulacao = false
      },
      "enviaRegulacao": function (motivo) { return _vm.enviaRegulacao(motivo); }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "divListVagas"
  }, [_c('div', {
    staticClass: "panel panel-default panel-table overflow-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "listsVagas tamanho-fixo-agenda-cima"
  }, _vm._l((_vm.vagas_unidade), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.getAtendimentosByUnidade(item[0].unidade_id)
        }
      }
    }, [_c('a', {
      staticClass: "list-group-item list-group-item-action list-group-item-warning",
      class: {
        ativa: _vm.selecionados.indexUnidadeAtiva === item[0].unidade_id
      }
    }, [_c('strong', [_vm._v(" " + _vm._s(_vm.getQtdProcedimentosAtendidos(item[0].unidade_id)) + " ")]), _vm._v(" " + _vm._s(_vm._f("uppercase")(item[0].unidade.nome))), _c('br'), _vm._v(" "), _c('span')])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "divListVagas"
  }, [_c('div', {
    staticClass: "panel panel-default panel-table"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "260px"
    }
  }, [(_vm.optionsCalendario.enabledDates) ? _c('date-picker', {
    attrs: {
      "config": _vm.optionsCalendario
    },
    on: {
      "dp-change": _vm.getUnidadesByDia
    },
    model: {
      value: (_vm.selecionados.data),
      callback: function($$v) {
        _vm.$set(_vm.selecionados, "data", $$v)
      },
      expression: "selecionados.data"
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "divListVagas"
  }, [_c('div', {
    staticClass: "panel panel-default panel-table overflow-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "listsVagas tamanho-fixo-agenda-cima"
  }, _vm._l((_vm.atendimentos_unidade), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      staticClass: "list-group-item list-group-item-action list-group-item-warning",
      staticStyle: {
        "cursor": "default"
      }
    }, [_vm._v(" " + _vm._s(_vm._f("uppercase")(item[0].procedimento_nome))), _c('br')])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "divListVagas"
  }, [_c('div', {
    staticClass: "panel panel-default panel-table overflow-box"
  }, [_vm._m(3), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "listsVagas tamanho-fixo-agenda-cima"
  }, _vm._l((_vm.procedimentos), function(item, index) {
    return _c('li', {
      key: index
    }, [(item.ativo) ? _c('a', {
      staticClass: "list-group-item list-group-item-action list-group-item-success",
      staticStyle: {
        "cursor": "default"
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    }), _vm._v(" "), _c('strong', [_vm._v(" " + _vm._s(_vm._f("uppercase")(item.procedimento_nome)) + " ")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Unidade: "), _c('strong', [_vm._v(" " + _vm._s(_vm._f("uppercase")(item.unidade.nome)) + " ")])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Data: "), _c('strong', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_atendimento)))]), _vm._v(" à partir das "), _c('b', [_vm._v(_vm._s(_vm._f("horaFormatada")(item.hora_inicial)))]), _vm._v(" horas.")]), _c('br')]) : _c('a', {
      staticClass: "list-group-item list-group-item-action list-group-item-warning",
      staticStyle: {
        "cursor": "default"
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-triangle"
    }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("uppercase")(item.procedimento_nome)))]), _c('br')])])
  }))])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 margin-bottom"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_c('button', {
    staticClass: "pull-left btn btn-default",
    on: {
      "click": function($event) {
        _vm.selecionaProcedimentos()
      }
    }
  }, [_vm._v("Selecionar "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [(!this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.disableBtConfirmar
    },
    on: {
      "click": _vm.confirma
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }, [_vm._v(" Confirmar")])]) : _vm._e(), _vm._v(" "), (this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.informacaoPendente
    }
  }, [_c('i', {
    staticClass: "fa fa-comment"
  }), _vm._v(" Solicitar informação pendente")]) : _vm._e(), _vm._v(" "), (this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.negativar
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" Negativar")]) : _vm._e(), _vm._v(" "), (this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.confirma
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Regular")]) : _vm._e(), _vm._v(" "), (!this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.showModalEnviarRegulacao = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Regulação")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-bottom": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-xs-12"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_vm._v("Selecione uma unidade")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-xs-12"
  }, [_c('h3', {
    staticClass: "panel-title",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('b', [_vm._v("Selecione uma data")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-xs-12"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_vm._v("Atendimentos da Unidade")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-xs-12"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_vm._v("Procedimentos")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-076768d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atendimentos/solicitacao/resolucaoAgrupado.vue
// module id = 790
// module chunks = 0